const GET_CRITERIAS = "GET_CRITERIAS";
const GET_CRITERIAS_SUCCESS = "GET_CRITERIAS_SUCCESS";
const GET_CRITERIAS_FAILURE = "GET_CRITERIAS_FAILURE";
const CLEAR_GET_CRITERIAS = "CLEAR_GET_CRITERIAS";

const criteriaSymbols = {
  GET_CRITERIAS_SUCCESS,
  GET_CRITERIAS_FAILURE,
  GET_CRITERIAS,
  CLEAR_GET_CRITERIAS,
};
export default criteriaSymbols;
